import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SETTINGS} from "../config/common.settings";

@Injectable({
  providedIn: 'root'
})
export class PackageService {
  constructor(private http: HttpClient) { }

  getAllPackageOptions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/package/get-options`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error.error);
        },
      });
    });
  }
}
